<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Nephrology</h2>
      <p>
        The department of Nephrology has a state of art dialysis unit and caters
        to the patients around this area.
      </p>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate3.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Nephrology Doctors",
      queryName: "Nephrology",
      teamName: "Nephrology team",
    };
  },
  components: { DoctorsList },
});
</script>
